import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { theme } from '@prophecy/theme/theme';
import { forwardRef } from 'react';
import styled from 'styled-components';
const StyledHrContainer = styled.div `
  margin: ${theme.spaces.x24} 0;
`;
const StyledHr = styled.hr `
  border: none;
  border-top: ${theme.spaces.x1} solid ${theme.colors.gray300};
  box-shadow: none;
  display: block;
  height: ${theme.spaces.x1};
`;
export const HrElement = forwardRef(({ className: _className, nodeProps, ...props }, ref) => {
    const { children } = props;
    return (_jsxs(StyledHrContainer, { ref: ref, contentEditable: false, children: [_jsx(StyledHr, { ...nodeProps }), children] }));
});
